const messages = {
    en: {
        delivery: {
            mode: {
                method: {
                    TAKE_AWAY: 'Take Away',
                    DELIVERY: 'Delivery',
                    SALON: 'Salon',
                },
                title: 'Delivery mode',
                deliveryMode: 'Delivery mode',
                mode: 'Mode',
                takeAway: 'Take Away',
                delivery: 'Delivery',
                AS_SON_AS_POSIBLE: 'As son as posible',
                SCHEDULED: 'Scheduled',
                estimatedTime: "Estimated time {hour}",
                deliveryTime: "Delivery time",
                distance: "Distance",
                salon: "Salon"

            },
        }
    },
    es: {
        delivery: {
            mode: {
                method: {
                    TAKE_AWAY: 'Retiro en local',
                    DELIVERY: 'Delivery',
                    SALON: 'Salon',
                },
                title: 'Entrega',
                deliveryMode: 'Modo de entrega',
                mode: 'Modo',
                takeAway: 'Retiro en local',
                delivery: 'Delivery',
                AS_SON_AS_POSIBLE: 'Lo antes posible',
                SCHEDULED: 'Programado',
                estimatedTime: "Hora estimada {hour}",
                deliveryTime: "Hora de entrega",
                distance: "Dist",
                salon: "Salon"
            },
        }
    },
    pt: {
        delivery: {
            mode: {
                method: {
                    TAKE_AWAY: 'Retiro en local',
                    DELIVERY: 'Delivery',
                    SALON: 'Salon',
                },
                title: 'Entrega',
                deliveryMode: 'Modo de entrega',
                mode: 'Mode',
                takeAway: 'Retiro en local',
                delivery: 'Delivery',
                AS_SON_AS_POSIBLE: 'Lo antes posible',
                SCHEDULED: 'Programado',
                estimatedTime: "Tempo estimado {hour}",
                deliveryTime: "tempo de entrega",
                distance: "Distance",
                salon: "Salon"
            },
        }
    }

}


export default messages
